import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs4 from "./page_us/Solution-US-4/SectionUs4.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
     useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Lightbox Maroc | Mur & Plafond Lumineux LED – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Lightbox au Maroc avec UNIK SYSTEM : murs lumineux, plafonds LED rétroéclairés et solutions design pour commerces, hôtels et espaces modernes. Devis gratuit."
  );

  setMeta(
    "keywords",
    "lightbox maroc, mur lumineux maroc, plafond lumineux LED maroc, lightbox murale maroc, retroeclairage LED maroc, enseigne lumineuse interieur maroc, plafond led design maroc, UNIK SYSTEM lightbox"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/lightbox-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Lightbox Maroc – Mur & Plafond Lumineux | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Solutions lightbox LED design pour murs et plafonds avec fort impact visuel au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/4.98201a1240ae8f8c8ab0.webp"
  );
  setMetaProperty("og:url", "https://unik-system.com/lightbox-maroc");
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Lightbox Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Mur lumineux et plafond LED design pour espaces modernes."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/4.98201a1240ae8f8c8ab0.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste des solutions lightbox LED et plafonds lumineux au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Lightbox & Éclairage",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Lightbox Murale LED"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Plafond Lumineux LED"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-lightbox");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-lightbox";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi une lightbox ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Une lightbox est un panneau lumineux rétroéclairé LED utilisé pour la décoration ou la communication visuelle."
        }
      },
      {
        "@type": "Question",
        name: "Où utiliser une lightbox ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Dans les commerces, hôtels, bureaux ou espaces modernes pour créer un impact visuel fort."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Design moderne, forte luminosité, faible consommation et longue durée de vie."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-lightbox");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-lightbox";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);


    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs4/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;